module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.link) ? _c('router-link', {
    staticClass: "list-box-item",
    class: {
      notify: _vm.unread
    },
    attrs: {
      "to": _vm.link
    }
  }, [_c('div', {
    staticClass: "image-circle"
  }, [_c('img', {
    attrs: {
      "src": _vm.userData.profileimg
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nano"
  }, [_vm._v(_vm._s(_vm.message)), _c('span', [_vm._v(_vm._s(_vm.dateShow))])])]) : _c('div', {
    staticClass: "list-box-item",
    class: {
      notify: _vm.unread
    }
  }, [_c('div', {
    staticClass: "image-circle"
  }, [_c('img', {
    attrs: {
      "src": _vm.userData.profileimg
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nano"
  }, [_vm._v(_vm._s(_vm.message)), _c('span', [_vm._v(_vm._s(_vm.dateShow))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30a3d1a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/NotificationItem.vue
// module id = 700
// module chunks = 1